import { ConnectionInterstitialContent } from '~/components/ConnectionInterstitial';
import {
  accountConnectors,
  AccountConnectorService,
} from '~/lib/configuration';

import GoogleSignInButton from '../GoogleConnectionForm/GoogleSignInButton';

const learnMoreLink =
  'https://help.clearbit.com/hc/en-us/categories/115001976668-Reveal#SubsectionGoogle_Analytics';

type GoogleConnectionFormProps = {
  onAuth: (config: AccountConnectorService) => void;
};

export default function GoogleConnectionForm({
  onAuth,
}: GoogleConnectionFormProps) {
  return (
    <ConnectionInterstitialContent
      button={
        <GoogleSignInButton onClick={() => onAuth(accountConnectors.google)} />
      }
      helpLink={learnMoreLink}
      text="Connect your Google Ads account to sync advertising audiences and conversion tracking data."
    />
  );
}
